import { render, staticRenderFns } from "./InformationPopup.vue?vue&type=template&id=669a6962&"
import script from "./InformationPopup.vue?vue&type=script&lang=ts&"
export * from "./InformationPopup.vue?vue&type=script&lang=ts&"
import style0 from "./InformationPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports